// extracted by mini-css-extract-plugin
export var emailBlockLink = "_je-0";